module.exports = __webpack_public_path__ + "static/media/ilu1.e365b6ac.png";